import * as React from "react";
import { Box } from "@mui/material";
import CclInfoTable from "../../../../components/common/cclInfoTable/cclInfoTable";
import { createMiscWorkTrainerTemplate, MiscWorkRecord } from "../miscWorkData";

export type TrainerDetailsProps = {
    record: MiscWorkRecord;
};

const TrainerDetails: React.FC<TrainerDetailsProps> = (props) => {
    return (
        <Box sx={{ width: 1, p: 3 }}>
            <CclInfoTable template={createMiscWorkTrainerTemplate()} data={props.record} readonly hideSave />
        </Box>
    );
};

export default TrainerDetails;